import { Box, Tooltip } from '@mui/material';
import Iconify from './Iconify';

// Renders nothing without a message, so callers decide when their own warning applies.
const WarningIcon = ({ message, icon = 'mdi:alert-outline', width = 15, height = 15 }) =>
  message ? (
    <Tooltip
      title={message}
      arrow
      componentsProps={{ tooltip: { sx: { bgcolor: '#3F3F3F', maxWidth: 320 } } }}>
      <Box component="span" display="inline-flex" alignItems="center">
        <Iconify icon={icon} width={width} height={height} color="#E0A23C" />
      </Box>
    </Tooltip>
  ) : null;

export default WarningIcon;
